import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';
import { NominationScrubbingStatus, ReviewerData } from '../../models';

export const updateCountryAwardNominationScrubbingStatus: (
  fetchContext: FetchContext,
  programId: number, 
  countryId: number, 
  nominationId: number, 
  scrubbingStatus: NominationScrubbingStatus,
  accessToken?: string,
) => Promise<void> = (fetchContext, programId, countryId, nominationId, scrubbingStatus, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nominations/${nominationId}/scrubbing-status`,
  {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(scrubbingStatus),
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update country award nomination scrubbing status'));
